import { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

function StockNotification(props) {
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [sendText, setSendText] = useState("");
	const [error, setError] = useState("");
	const [success, setSuccess] = useState(false);
	const recaptchaRef = useRef("");

	function submitStockNotification(id) {
		const formData = {
			"email": email,
			"phone": phone,
			"product_id": id,
			"g-recaptcha-response": recaptchaRef.current.getValue()
		};
		setError("");

		fetch(
			'/forms/m_stockNotificationSubmit',
			{
				method: 'POST',
				body: JSON.stringify(formData),
				headers: {
					'Content-Type': 'application/json',
					'HTTP_X_REQUESTED_WITH': 'xmlhttprequest'
				}
			}
		).then(response => {
			return response.json();
		}).then(data => {
			if(Number.isInteger(data)) {
				setSuccess(true);
			} else {
				setError(data);
			}
		});
	}

	if(success) {
		return (
			<div className={"oos-container"}>
				<h5>Thank you for requesting stock updates on this item. We will email you once available.</h5>
			</div>
		);
	}

	return (
		<div className={"oos-container"}>
			<div className={"oos-heading"}>
				<i>This item is currently</i>
				<h3>OUT OF STOCK</h3>
			</div>
			<div className={"oos-sub-heading"}>
				<b>NOTIFY WHEN AVAILABLE</b>
				<div>Get an email and/or text message when this<br/> item becomes available again</div>
			</div>
			<input type="email" name="email" className={"form-control"} id="emailaddress" placeholder="Email" onChange={(e) => setEmail(e.target.value)}/>
			<input type="tel" name="phone" className={"form-control"} id="phonenumber" placeholder="Phone" onChange={(e) => setPhone(e.target.value)}/>
			<label className={"checkmark-container"}>
				<input id="sendtext" name="sendText" type="checkbox" onChange={(e) => setSendText(sendText === "on" ? "" : "on")}/> Send me a text notification (msg & data rates may apply)
				<span className={"checkmark"}></span>
			</label>
			<input type="hidden" name="product_id" id='product_id' value={props.product.id}/>
			<ReCAPTCHA ref={recaptchaRef} sitekey="6LfPl9kZAAAAAMb73gUalIfWxJQw_FdYAtxwWdol"/>
			<div id='errors'>{error}</div>	
			<button id="submit_stock_notification" type="submit" className={"btn"} onClick={() => submitStockNotification(props.product.id)}>NOTIFY ME<img className={"oos-arrow"} src="https://poolsupplies.nyc3.cdn.digitaloceanspaces.com/media/0c2c557ed827239ed8b2b0ee368eacc5.png" alt="arrow"/></button>
			<hr/>
			<div className={"oos-footer"}>
				<div className={"red"}><b>OR GIVE US A CALL</b></div>
				<div><b>1-800-356-3025</b></div>
				<div>for additional options or substitutions</div>
			</div>
		</div>
	);
}

export default StockNotification;

